import InternalReports from "./InternalReports";
export default InternalReports;
